export default __webpack_public_path__ + "static/media/nav_all.ec8a6ae2.svg";